module.exports = __webpack_public_path__ + "static/media/gameInfo-1.165db900.png";